import { styled } from 'styled-components';
import { black, lighterGrey, white, yellow } from './colors';

const StyledButton = styled.button<{
  $disabled?: boolean;
  $secondary?: boolean;
  $large?: boolean;
}>`
  background-color: ${({ $secondary }) => ($secondary ? lighterGrey : yellow)};
  font-size: ${(props) => (props.$large ? 24 : 15)}px;
  text-transform: uppercase;
  font-family: inherit;
  font-weight: bold;
  padding: 8px 16px;
  border-radius: 8px;
  color: ${({ $disabled, $secondary }) =>
    $disabled && $secondary ? white : black};
  border-width: 0px;
  cursor: ${({ $disabled }) => ($disabled ? 'cursor' : 'pointer')};
  opacity: ${({ $disabled }) => ($disabled ? 0.35 : 1)};
  margin: 10px 0px;

  &:active {
    transform: scale(${(props) => (props.$disabled ? 1 : 0.8)});
    transition: transform 0.2s ease-in-out;
  }
`;

export const Button: React.FC<{
  disabled?: boolean;
  secondary?: boolean;
  onClick?: () => void;
  children: React.ReactNode;
  type?: string;
  buttonType?: 'submit' | 'button';
  large?: boolean;
  style?: React.CSSProperties;
}> = ({
  large = false,
  type = 'primary',
  disabled = false,
  secondary = false,
  buttonType = 'button',
  children,
  onClick,
  style,
}) => {
  return (
    <StyledButton
      onClick={() => !disabled && onClick && onClick()}
      $disabled={disabled}
      $secondary={secondary}
      $large={large}
      type={buttonType}
      style={style}
    >
      {children}
    </StyledButton>
  );
};
